import RouteMeta from '@/types/RouteMeta'
import authStore from '@/stores/auth.store'
import ApplicationPortfolioView from '@/units/ds/views/ApplicationPortfolioView.vue'

const generalRoutes = [
  {
    path: '/',
    redirect: () => ({
      name:
        import.meta.env.VITE_MODE === 'local' ||
        window.location.href.includes(
          import.meta.env.VITE_B2C_BASE_URL_FALLBACK as string,
        )
          ? 'ds'
          : 'b2b',
    }),
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('@/pages/MaintenanceView.vue'),
    meta: {
      allowUnauthorized: true,
      navItem: false,
      title: 'Maintenance',
      suppressCmp: true,
    } as RouteMeta,
  },
  {
    path: '/datenschutz',
    name: 'Dataprotection',
    component: () => import('@/units/ds/views/Dataprotection.vue'),
    meta: {
      allowUnauthorized: true,
      navItem: false,
      title: 'Dataprotection',
      suppressCmp: true,
      wizardExcluded: true,
    } as RouteMeta,
  },
  {
    path: '/dataprotection',
    redirect: () => ({
      name: 'Dataprotection',
    }),
  },
  {
    path: '/impressum',
    name: 'Imprint',
    component: () => import('@/pages/ImprintView.vue'),
    meta: {
      allowUnauthorized: true,
      navItem: false,
      title: 'Imprint',
      suppressCmp: true,
      wizardExcluded: true,
    } as RouteMeta,
  },
  {
    path: '/imprint',
    redirect: () => ({
      name: 'Imprint',
    }),
  },
  {
    path: '/documents/:uuid/preview',
    name: 'DocumentsPreview',
    component: () => import('@/pages/DocumentPreviewView.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/pages/RegisterView.vue'),
    meta: {
      allowUnauthorized: true,
      navItem: false,
      title: 'Account erstellen',
      suppressCmp: true,
    } as RouteMeta,
  },
  {
    path: '/application',
    name: 'Application',
    component: () => import('@/pages/ApplicationView.vue'),
    meta: {
      allowUnauthorized: true,
      navItem: false,
      title: 'Test-Bewerbung mit Auto-Login',
      suppressCmp: true,
      wizardExcluded: true,
    } as RouteMeta,
  },
  {
    path: '/render/application-portfolio',
    name: 'render.application-portfolio',
    component: ApplicationPortfolioView,
    meta: {
      allowUnauthorized: true,
      navItem: false,
      noNav: true,
      suppressCmp: true,
    } as RouteMeta,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    component: () =>
      import(
        /* webpackChunkName: "PageNotFound" */ '@/pages/PageNotFoundView.vue'
      ),
    meta: {
      navItem: false,
      title: '404 - Seite nicht gefunden',
    } as RouteMeta,
  },
  {
    path: '/newsletter-unsubscription',
    name: 'newsletter-unsubscription',
    component: () =>
      import('@/units/ds/views/profile/NewsletterUnsubscription.vue'),
    meta: {
      allowUnauthorized: true,
      title: 'Newsletter Unsubscription',
      navItem: false,
      topNav: false,
      suppressCmp: true,
    } as RouteMeta,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('@/pages/PageNotFoundView.vue'),
    beforeEnter: () => {
      authStore.logoutUser()
      return false
    },
  },
]

export default generalRoutes
